export const INITIAL_EXPECTATION_QUESTION_DATAHUB_LABEL =
  'Quais eram suas expectativas iniciais para a comunidade e como elas não foram atendidas?'
